<template>
  <div>
    <el-drawer
      :visible.sync="attachmentUploadVisible"
      :title="handleFlag === 'upload' ? '附件' : '查看附件'"
      direction="rtl"
      size="50%"
      :modal-append-to-body="false"
      :before-close="handleClose"
    >
      <div class="attachment-wrapper-content">
        <div class="attachment-wrapper">
          <div class="tip-wrap">
            <div class="red">提示：</div>
            <div class="content" style="padding: 0">
              <p>根据物资交付资料要求，建议提供如下文件</p>
            </div>
          </div>
          <tableList
            :index-show="true"
            row-key="id"
            :loading="false"
            :table-data="tableData"
            :table-label="tableLabel"
          >
            <template #attachmentMust="{ scope: { row } }">
              <span v-if="row.attachmentMust === '1'" style="color: #f0250f">必传</span>
              <span v-else>非必传</span>
            </template>
            <template #uploadFileName="{ scope: { row, $index } }">
              <div style="padding: 4px 0">
                <el-upload
                  v-if="
                    row.attachList &&
                    row.attachList.length < 5 &&
                    handleFlag === 'upload'
                  "
                  ref="uploadFile"
                  :action="uploadUrl"
                  :headers="headers"
                  :show-file-list="false"
                  :auto-upload="true"
                  :on-success="getFileInfo"
                  :before-upload="handleBeforeUpload"
                >
                  <eui-btn
                    icon="eicon-upload"
                    icon-position="left"
                    type="secondary"
                    @click="handleUpload($index)"
                    >上传附件
                  </eui-btn>
                </el-upload>
                <div
                  v-for="(item, index) in row.attachList"
                  :key="index"
                  class="flex-sc"
                  :class="{
                    'margin-t10':
                      row.attachList.length > 1 && handleFlag === 'upload',
                  }"
                >
                  <eui-icon
                    icon="eicon-r-l-wenjian"
                    font-size="16px"
                    style="margin-right: 4px"
                  ></eui-icon>
                  <div @click="viewFile(item.url)">
                    <eui-tooltip-over
                      :line="1"
                      :tooltip-style="{
                        width: '180px',
                        color: '#0064c8',
                        height: '16px',
                      }"
                      :content="item.name"
                    >
                    </eui-tooltip-over>
                  </div>

                  <div @click="handleDelFile($index, index)">
                    <eui-icon
                      v-if="handleFlag === 'upload'"
                      icon="eicon-r-l-guanbi"
                      font-size="14px"
                    ></eui-icon>
                  </div>
                </div>
              </div>
            </template>
          </tableList>
        </div>
        <div class="flex-all-center drawer-footer">
          <eui-btn
            type="secondary"
            style="margin-right: 30px"
            @click="handleClose"
            >取消</eui-btn
          >
          <eui-btn
            v-if="handleFlag === 'upload'"
            type="primary"
            @click="handleConfirm"
            >确定</eui-btn
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import api from '../../api/order';
import productApi from '@/modules/projectA/api/product';
import tableList from './e-table-list';
import { epecToken } from '../../utils/globalData';

export default {
  name: 'AttachmentUpload',
  components: {
    tableList,
  },
  props: {
    categoryCode: String,
    attachmentUploadVisible: Boolean,
    handleFlag: String,
    viewTableData: Array,
    type: String,
  },
  data() {
    return {
      fileIndex: null,
      uploadUrl: api.orderAttachUpload,
      headers: epecToken,
      tableData: [],
      tableLabel: [
        {
          label: '交付资料清单',
          param: 'attachmentName',
          align: 'left',
          headerText: 'left',
        },
        {
          label: '是否必传',
          param: 'attachmentMust',
          align: 'center',
          slot: 'attachmentMust',
          width: '120',
        },
        {
          label: '文件名称',
          param: '',
          align: 'left',
          headerText: 'left',
          slot: 'uploadFileName',
        },
      ],
    };
  },
  mounted() {
    this.ruleQueryList();
  },
  methods: {
    viewFile(url) {
      window.open(url);
    },
    handleDelFile(tableIndex, fileIndex) {
      this.tableData[tableIndex].attachList.splice(fileIndex, 1);
    },
    handleUpload(index) {
      this.fileIndex = index;
    },
    handleBeforeUpload(file) {
      const size = file.size / 1024 / 1024;
      if (size > 200) {
        this.$message({ message: '附件不能超过200M。', type: 'warning' });
        return false;
      }
      return true;
    },
    getFileInfo(res, file) {
      if (this.tableData[this.fileIndex].attachList.length === 5) {
        this.$message.warning({ message: '只能上传五个附件。' });
        return false;
      }
      if (res.success) {
        const params = {
          url: file.response.data.url,
          name: file.name,
          categoryReviewAttachmentId: this.tableData[this.fileIndex].id || '', // 空是其他
          type: 1,
          tag: this.tableData[this.fileIndex].attachmentName || '',
        };
        this.tableData[this.fileIndex].attachList.push(params);
      }
    },
    handleConfirm() {
      const attachmentMustArr = this.tableData.filter(
        (item) => Number(item.attachmentMust) === 1
      );
      const noAttachArr = attachmentMustArr.filter(
        (item) => item.attachList.length === 0
      );
      if (noAttachArr.length > 0) {
        this.$message.warning('请先上传“必传”附件后再点击“确定”按钮。');
        return false;
      }
      console.log(this.tableData, 'this.tableData');
      this.$emit('dealAttachmentFileData', this.tableData);
      this.handleClose();
    },
    handleClose() {
      this.$emit('update:attachmentUploadVisible', false);
    },

    //attachmentType:采购合同：0  、 附件：1    共同清单接口
    async ruleQueryList() {
      let params = {
        sceneType: 1,//场景类型 固定传1
        categoryCode: this.categoryCode,
        attachmentType: 1,
      }
      const res = await productApi.ruleQueryList(params);

      if (res.code === '200') {
        let attachmentList = res.data.filter((item) => item.attachmentType === '1');

        this.tableData = attachmentList.length > 0 ? attachmentList[0].reviewRuleList : [];

        this.tableData.forEach((item) => {
          this.$set(item, 'attachList', []);
          this.viewTableData.forEach((viewData) => {
            if (item.id === viewData.categoryReviewAttachmentId) {
              item.attachList.push({
                name: viewData.name,
                url: viewData.url,
                categoryReviewAttachmentId: viewData.categoryReviewAttachmentId,
                tag: item.attachmentName,
                type: 1,
              });
            }
          });
        });
        // this.tableData.forEach((item) => {
        //   this.viewTableData.forEach((viewData) => {
        //     if (item.id === viewData.id) {
        //       item.attachList = viewData.attachList;
        //     }
        //   });
        // });

        // 封装其他类型得文件数据
        const otherAttachList = this.viewTableData.filter(
          (item) => !item.categoryReviewAttachmentId
        );
        otherAttachList.forEach(item => {
          item.type = 1;
          item.tag = '其他';
        })
        this.tableData.push({
          attachmentName: '其他',
          attachmentMust: 0,
          attachList: otherAttachList || [],
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.attachment-wrapper-content {
  height: calc(100vh - 42px);
  display: flex;
  flex-direction: column;
}
.attachment-wrapper {
  padding: 20px;
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  .tip-wrap {
    display: flex;
    background-color: #e8efff;
    padding: 10px 20px;
    margin-top: 10px;
    font-size: 14px;
    margin-bottom: 20px;

    .red {
      color: #ef4c56;
      display: inline-block;
    }
  }
}

.drawer-footer {
  flex-shrink: 0;
  text-align: right;
  background: var(--w-0-ffffff, #fff);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  height: 70px;
  line-height: 70px;
  z-index: 100;
  padding: 0 20px;
  border-top: 1px solid #e6e6e6;
}

::v-deep .el-drawer__header {
  height: 40px;
  line-height: 40px;
  background-color: #f5f5f5;
  margin-bottom: 0;
  padding: 16px 20px 0 20px;
  font-size: 14px;
  font-family: SourceHanSansCN-Medium;
  color: #333;

  span,
  .el-drawer__close-btn {
    margin-bottom: 20px;
    color: #333;
  }
}
</style>
